const queue = [];
let interval;

const enqueue = ({
  eventName,
  payload,
}) => {
  queue.push({ eventName, payload });

  if (!interval) {
    interval = setInterval(() => {
      if (typeof window !== "undefined" && window.tagular) {
        clearInterval(interval);
        queue.forEach(({ eventName, payload }) => {
          if (window.tagular) {
            window.tagular(eventName, payload);
          }
        });
        // Clear the queue after processing
        queue.length = 0;
      }
    }, 300);
  }
};

const tagular = (
  eventName,
  payload,
) => {
  console.log('tagular', eventName, payload)
  if (!validatePayload(eventName, payload)) {
    return;
  }

  const event = EventDefinitions[eventName].eventType;
  if (!event) {
    console.error(`${eventName} is not a supported event`);
    return;
  }

  const body = {
    "@type": event,
    ...payload,
  };

  if (typeof window !== "undefined" && window.tagular) {
    try {
      window.tagular("beam", body);
    } catch (e) {
      console.error("Tagular:", e);
    }
  } else {
    console.warn("Tagular: Not found in window");
    enqueue({ eventName, payload });
  }
};
